import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '@/components/SectionTitle';
import Seo from '@/seo/Seo';
import { PAGE_SEO } from '@/seo/seoConfig';
import { breadcrumbSchema } from '@/seo/schemas';
import { Sparkles, Users, Music, Utensils, Palette, Bird, BookOpen, Calendar } from 'lucide-react';

const ACTIVITIES = [
  { icon: BookOpen, title: 'Bible Lessons' },
  { icon: Music, title: 'Worship' },
  { icon: Bird, title: 'Games' },
  { icon: Palette, title: 'Crafts' },
  { icon: BookOpen, title: 'Memory Verses' },
  { icon: Users, title: 'Group Activities' },
  { icon: Utensils, title: 'Snacks' },
  { icon: Sparkles, title: 'Prayer Time' },
];

export default function SummerCamp() {
  return (
    <div>
      <Seo
        title={PAGE_SEO.summerCamp.title}
        titleExact
        description={PAGE_SEO.summerCamp.description}
        keywords={PAGE_SEO.summerCamp.keywords}
        path="/services/summer-camp"
        jsonLd={[breadcrumbSchema([
          { name: 'Home', path: '/' },
          { name: 'Services', path: '/services' },
          { name: 'Summer Camp', path: '/services/summer-camp' },
        ])]}
      />
      <section className="gradient-purple text-white py-12 sm:py-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <Link to="/services" className="text-moj-gold text-sm hover:underline">← Back to all services</Link>
          <h1 className="font-serif text-4xl sm:text-5xl text-white mt-3 mb-3">Summer Camp</h1>
          <p className="text-lg text-white/90 max-w-3xl">A summer adventure your children will remember forever — packed with the Word, worship, games and friendship.</p>
          <Link to="/contact" className="btn-gold mt-6 inline-flex"><Calendar size={16}/> Register Interest</Link>
        </div>
      </section>

      <section className="py-16 bg-moj-cream">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <SectionTitle kicker="What to expect" title="5 days. 1 Saviour. Unforgettable memories." center />
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8">
            {ACTIVITIES.map((a) => (
              <div key={a.title} className="card-moj p-5 text-center">
                <a.icon size={28} className="text-moj-gold-deep mx-auto mb-2"/>
                <div className="font-serif text-sm text-moj-purple-deep">{a.title}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 gradient-soft-cream">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 grid md:grid-cols-2 gap-10 items-center">
          <div>
            <SectionTitle kicker="Trusted hands" title="Our Volunteer Team" />
            <p className="text-moj-charcoal/80">All summer camp leaders are church-vetted, Garda-checked, and trained in safeguarding. Children are looked after with prayer, care and excellence.</p>
          </div>
          <img src="https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=1000&h=700&fit=crop" alt="Children at summer camp" className="rounded-2xl shadow-xl"/>
        </div>
      </section>

      <section className="py-16 bg-moj-cream">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 card-moj p-8">
          <SectionTitle kicker="Parents’ information" title="Everything you need to know" />
          <ul className="space-y-2 text-moj-charcoal/80">
            <li>• Ages 5–14 • Free of charge • Snacks provided</li>
            <li>• Drop off at 9:00, pick up at 16:00 from the main church hall</li>
            <li>• Closing celebration service on Friday evening with families invited</li>
            <li>• Limited spaces — please register your interest early</li>
          </ul>
          <Link to="/contact" className="btn-primary mt-6 inline-flex">Register your interest</Link>
        </div>
      </section>
    </div>
  );
}
